var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumb',{attrs:{"breadcrumb_link":_vm.notice_breadcrumb}}),_c('HrBoardArticleRead',{attrs:{"board-article-id":Number(_vm.$route.params.boardArticleId)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }